// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.reservation[data-v-58b5346a] {\n\tdisplay: flex;\n\tflex-direction: row;\n\tmargin: 30px 38px;\n\tborder: 1px solid var(--color-border);\n\tborder-radius: var(--border-radius);\n\tpadding: 20px;\n\talign-items: center;\n}\n.event[data-v-58b5346a] {\n\tflex-grow: 1;\n}\n.event-name[data-v-58b5346a] {\n\tfont-size: larger;\n\tfont-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
